import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, HttpModule, Headers, RequestOptions } from '@angular/http';
import { UserService } from '../../services/user.service';
import { LinkService } from '../../services/link.service';
import { DragulaService } from 'ng2-dragula';
import { Chart } from 'chart.js';
import * as moment from 'moment';
import * as momentTz from 'moment-timezone';
import * as _ from 'lodash';
declare var jQuery: any;

@Component({
  selector: 'page-links',
  templateUrl: 'links.html',
  styleUrls: ["../../../node_modules/dragula/dist/dragula.css"]
})
export class LinksPage implements OnInit, OnDestroy {

  userService;
  linkService;
  profile: any;
  links = [];
  linkIds = [];
  displayLinks = [];
  displayLinksSub: any;
  editing = '';
  updating = '';
  resetInputs = '';
  routeSub;
  routeId;
  settings;
  timezonePref;
  displayOffset;

  clickAnalytics: any = {
    total: 0,
    twoWeeks: 0,
    twoWeeksByDay: { '0': 0, '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0 },
    oneWeek: 0,
    oneWeekByDay: { '0': 0, '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0 },
    links: {}
  };
  viewAnalytics: any = {
      total: 0,
      twoWeeks: 0,
      twoWeeksByDay: { '0': 0, '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0 },
      oneWeek: 0,
      oneWeekByDay: { '0': 0, '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0 }
  };
  loaded = {
      clicks: false,
      views: false,
  }

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public http: Http,
    public dragulaService: DragulaService,
  ) {
    if (!document.getElementById('style1')) { this.insertLink('style1', 'assets/vendor/bootstrap/bootstrap.css') }
    if (!document.getElementById('style2')) { this.insertLink('style2', 'assets/vendor/bootstrap-select/dist/css/bootstrap-select.css') }
    if (!document.getElementById('style3')) { this.insertLink('style3', 'assets/vendor/Camera-master/css/camera.css') }
    if (!document.getElementById('style4')) { this.insertLink('style4', 'assets/vendor/bootstrap-mega-menu/css/menu.css') }
    if (!document.getElementById('style5')) { this.insertLink('style5', 'assets/fonts/font-awesome/css/fontawesome-all.min.css') }
    if (!document.getElementById('style6')) { this.insertLink('style6', 'assets/vendor/owl-carousel/owl.carousel.css') }
    if (!document.getElementById('style7')) { this.insertLink('style7', 'assets/vendor/owl-carousel/owl.theme.css') }
    if (!document.getElementById('style8')) { this.insertLink('style8', 'assets/vendor/WOW-master/css/libs/animate.css') }
    if (!document.getElementById('style9')) { this.insertLink('style9', 'assets/vendor/hover.css') }
    if (!document.getElementById('style10')) { this.insertLink('style10', 'assets/fonts/icon/font/flaticon.css') }
    if (!document.getElementById('style11')) { this.insertLink('style11', 'assets/vendor/fancybox/dist/jquery.fancybox.min.css') }
    if (!document.getElementById('style12')) { this.insertLink('style12', 'assets/vendor/jquery-ui/jquery-ui.min.css') }
    if (!document.getElementById('style13')) { this.insertLink('style13', 'assets/css/material-kit.css') }
    if (!document.getElementById('style14')) { this.insertLink('style14', 'assets/css/style-app.css') }
    this.userService = new UserService();
    this.linkService = new LinkService();
    this.dragulaService.drop.subscribe((value) => {
      this.onDrop(value);
    });
    this.dragulaService.drag.subscribe((value) => {
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    });
    this.dragulaService.dragend.subscribe((value) => {
        document.getElementsByTagName('body')[0].style.overflow = 'scroll';
    })
  }

  ngOnInit() {
  }

  insertLink(id, linkPath) {
    let link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = linkPath;
    document.head.appendChild(link);
  }

  insertScript(id, scriptPath) {
    let script = document.createElement('script');
    script.id = id;
    script.src = scriptPath;
    document.head.appendChild(script);
  }

  async userLoaded(user) {
    if (!user || !user.uid) window.location.href = "/login";
    this.route.params.subscribe(async (params) => {
        this.routeId = params['id'];
        if (this.routeId || user) {
            if (this.routeId) {
                this.profile = await this.userService.getProfileByUsername(this.routeId);
                if (!this.profile) this.goTo('404');
                this.routeId = this.profile.$id;
            }
            this.settings = await this.userService.getUserSettings(this.routeId || user.uid);
            this.timezonePref = this.settings.timezone || momentTz.tz.guess();
            // this.displayOffset = momentTz.tz.zone(this.timezonePref).parse(this.timezonePref);
            if (this.routeId && this.settings && this.settings.managedBy) {
            let hasAccess = _.find(this.settings.managedBy, (managingUser) => { return user.uid === managingUser.$id });
            } else if (this.routeId && this.routeId !== user.uid) {
            // If a user hits this point, they are viewing an admin portal they don't have access to.
            // That is the cause for the reroute here.
            this.goTo('display', this.routeId);
            }
            this.profile = await this.userService.getProfile(this.routeId || user.uid);
            this.links = await this.linkService.getUserLinks(this.routeId || user.uid) || [];
            this.links = _.sortBy(this.links, 'displayOrder');
            this.displayLinksSub = this.linkService.getUserLinksSub(this.routeId || user.uid).onSnapshot((data) => {
              this.displayLinks = [];
              data.forEach((doc) => {
                let tempDoc = doc.data();
                tempDoc.url = tempDoc.url.replace('https://', '').replace('http://', '');
                  this.displayLinks.push(tempDoc);
              });
              this.displayLinks = _.sortBy(this.displayLinks, 'displayOrder');
            });
            const bag: any = this.dragulaService.find('linksDrag');
            if (bag !== undefined ) this.dragulaService.destroy('linksDrag');
            this.dragulaService.setOptions('linksDrag', {
                moves: (el, container, handle) => {
                    return handle.className.includes('handle');
                }
            });
            this.initDateTimes();

            if (this.profile) {
                this.profile.views = await this.userService.getViews(this.routeId || user.uid);
            }

            this.links = _.forEach(this.links, async (link) => {
                this.linkIds.push(link.$id);
            })

            const headers = new Headers();
            headers.append('Access-Control-Allow-Origin', '*');
            headers.append('Access-Control-Allow-Credentials', 'true');

            const options = new RequestOptions({headers: headers});

            let views = this.http.post('https://us-central1-bitl-it-analytics.cloudfunctions.net/getProfileViewAnalytics', {
                userId: user.uid
            }, options).subscribe(async (res: any) => {
                let ress = JSON.parse(res._body || res || "{}");
                this.viewAnalytics = ress;
                this.loaded.views = true;
                views.unsubscribe();
            })

            let response = this.http.post('https://us-central1-bitl-it-analytics.cloudfunctions.net/getLinkClickAnalytics', {
                links: this.linkIds,
            }, options).subscribe(async (res: any) => {
                let ress = JSON.parse(res._body || res || "{}");
                this.links = _.forEach(this.links, async (link) => {
                    this.clickAnalytics.total += ress[link.$id].total;
                    this.clickAnalytics.oneWeek += ress[link.$id].oneWeek;
                    this.clickAnalytics.twoWeeks += ress[link.$id].twoWeeks;
                    link.total = ress[link.$id].total;
                    link.oneWeek = ress[link.$id].oneWeek;
                    this.addDayStatsToClickAnalytics(ress[link.$id], link.$id);
                })
                this.loaded.clicks = true;
                response.unsubscribe();
            })
            let loadedCheck = setInterval(() => {
                if (this.loaded.clicks && this.loaded.views) {
                    this.initCharts();
                    clearInterval(loadedCheck);
                }
            }, 600);
        }
    });
  }

  addDayStatsToClickAnalytics(obj, linkId) {
      var yx = 0;
      this.clickAnalytics.links[linkId] = {oneWeekByDay: {}};
      for (yx = 0; yx <= 6; yx++) {
          this.clickAnalytics.oneWeekByDay[yx] += obj.oneWeekByDay[yx];
          this.clickAnalytics.twoWeeksByDay[yx] += obj.twoWeeksByDay[yx];
          this.clickAnalytics.links[linkId].oneWeekByDay[yx] = obj.oneWeekByDay[yx];
      }
  }

  initDateTimes() {
    for (var i = 0; i < this.links.length; i++) {
      let findStart = `#starttime${i}`;
      let previousStart = this.links[i].startTime;
      let findEnd = `#endtime${i}`;
      let previousEnd = this.links[i].endTime;
      setTimeout(() => {
        previousStart ? jQuery(findStart).datetimepicker({date: previousStart}) : jQuery(findStart).datetimepicker();
        previousEnd ? jQuery(findEnd).datetimepicker({date: previousEnd}) : jQuery(findEnd).datetimepicker();
      }, 1000);
    //   setTimeout(() => {
    //     previousStart ? jQuery(findStart).datetimepicker({date: previousStart}) : jQuery(findStart).datetimepicker();
    //     previousEnd ? jQuery(findEnd).datetimepicker({date: previousEnd}) : jQuery(findEnd).datetimepicker();
    //   }, 3000);
    //   setTimeout(() => {
    //     previousStart ? jQuery(findStart).datetimepicker({date: previousStart}) : jQuery(findStart).datetimepicker();
    //     previousEnd ? jQuery(findEnd).datetimepicker({date: previousEnd}) : jQuery(findEnd).datetimepicker();
    //   }, 5000);
    }
  }

  generateLabels() {

  }

  initCharts() {
    var ctx: any = document.getElementById("viewsChart");
    if (!ctx) return;
    ctx.height = 30;
    var pastWeekClicks = this.clickAnalytics.oneWeekByDay;
    var pastWeekViews = this.viewAnalytics.oneWeekByDay;
    var viewsChart = new Chart(ctx, {
        type: 'line',
        data: {
            labels: ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"],
            datasets: [{
                    label: 'Clicks',
                    data: [pastWeekClicks[0], pastWeekClicks[1], pastWeekClicks[2], pastWeekClicks[3], pastWeekClicks[4], pastWeekClicks[5], pastWeekClicks[6]],
                    backgroundColor: [
                        'rgba(226, 226, 226, 0.1)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 159, 64, 0.2)'
                    ],
                    borderColor: [
                        'rgba(172, 236, 186, 0.5)',
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)',
                        'rgba(153, 102, 255, 1)',
                        'rgba(255, 159, 64, 1)'
                    ],
                    borderWidth: 2,
                    pointBackgroundColor: 'rgba(172, 236, 186, 0.5)',
                    pointBorderColor: 'rgba(172, 236, 186, 0.5)',
                    pointBorderWidth: 6,
                    pointHoverBorderColor: 'rgba(172, 236, 186, 0.3)',
                    pointHoverBorderWidth: 10,
                    lineTension: 0,
                },
                {
                    label: 'Views',
                    data: [pastWeekViews[0], pastWeekViews[1], pastWeekViews[2], pastWeekViews[3], pastWeekViews[4], pastWeekViews[5], pastWeekViews[6]],
                    backgroundColor: [
                        'rgba(172, 236, 186, 0.1)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 159, 64, 0.2)'
                    ],
                    borderColor: [
                        'rgba(172, 236, 186, 255)',
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)',
                        'rgba(153, 102, 255, 1)',
                        'rgba(255, 159, 64, 1)'
                    ],
                    borderWidth: 3,
                    pointBackgroundColor: 'rgba(172, 236, 186, 0.5)',
                    pointBorderColor: 'rgba(172, 236, 186, 255)',
                    pointBorderWidth: 6,
                    pointHoverBorderColor: 'rgba(172, 236, 186, 0.3)',
                    pointHoverBorderWidth: 10,
                    lineTension: 0,
                }
            ]
        },
        options: {
            // defaultFontFamily: "Karla, Helvetica, sans-serif",
            defaultFontSize: "15px",
            defaultFontStyle: "bold",
            animation: {
                animateScale: !1,
                duration: 0
            },
            layout: {
                padding: {
                    top: 20
                }
            },
            legend: {
                display: false
            },
            tooltips: {
                backgroundColor: 'rgba(100, 100, 100, .8)',
                custom: function(tooltip) {
                    if (!tooltip) return;
                    // disable displaying the color box;
                    tooltip.displayColors = false;
                }
            },
            scales: {
                xAxes: [{

                    gridLines: {
                        display: !1
                    },
                    ticks: {
                        maxTicksLimit: 3,
                    }
                }],
                yAxes: [{
                    display: false,
                    gridLines: {
                        display: !1
                    },
                    ticks: {
                        beginAtZero: !0,
                        maxTicksLimit: 3,
                        callback: function(e) {
                            return 0 === e || e % 1 != 0 ? "" : e
                        }
                    }
                }]
            }
        }
    });
    for (var x = 0; x < this.links.length; x++) {
      let ctx: any = document.getElementById(`chart${x}`);
      if (!ctx) return;
      ctx.height = 40;
      let currentLink = this.clickAnalytics.links[this.links[x].$id];
      let myChart = new Chart(ctx, {
          type: 'line',
          data: {
              labels: ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"],
              datasets: [{
                  label: 'Clicks',
                  data: [currentLink.oneWeekByDay[0], currentLink.oneWeekByDay[1], currentLink.oneWeekByDay[2], currentLink.oneWeekByDay[3], currentLink.oneWeekByDay[4], currentLink.oneWeekByDay[5], currentLink.oneWeekByDay[6]],
                  backgroundColor: [
                      'rgba(226, 226, 226, 0.4)',
                      'rgba(54, 162, 235, 0.2)',
                      'rgba(255, 206, 86, 0.2)',
                      'rgba(75, 192, 192, 0.2)',
                      'rgba(153, 102, 255, 0.2)',
                      'rgba(255, 159, 64, 0.2)'
                  ],
                  borderColor: [
                      'rgba(226, 226, 226, 255)',
                      'rgba(54, 162, 235, 1)',
                      'rgba(255, 206, 86, 1)',
                      'rgba(75, 192, 192, 1)',
                      'rgba(153, 102, 255, 1)',
                      'rgba(255, 159, 64, 1)'
                  ],
                  borderWidth: 2,
                  pointBackgroundColor: 'transparent',
                  pointBorderColor: 'rgba(196, 196, 196, 1)',
                  pointBorderWidth: 6,
                  pointHoverBorderColor: 'rgba(196, 196, 196, 0.5)',
                  pointHoverBorderWidth: 10,
                  lineTension: 0,
              }]
          },

          options: {

              // defaultFontFamily: "Karla, Helvetica, sans-serif",
              defaultFontSize: "15px",
              defaultFontStyle: "bold",
              animation: {
                  animateScale: !1,
                  duration: 0
              },
              layout: {
                  padding: {
                      top: 20
                  }
              },
              legend: {
                  display: false
              },
              tooltips: {
                  backgroundColor: 'rgba(100, 100, 100, .8)',
                  custom: function(tooltip) {
                      if (!tooltip) return;
                      // disable displaying the color box;
                      tooltip.displayColors = false;
                  }
              },
              scales: {
                  xAxes: [{
                      gridLines: {
                          display: !1
                      }
                  }],
                  yAxes: [{
                      gridLines: {
                          display: !1
                      },
                      ticks: {
                          beginAtZero: !0,
                          maxTicksLimit: 3,
                          callback: function(e) {
                              return 0 === e || e % 1 != 0 ? "" : e
                          }
                      }
                  }]
              }
          }
      });
    }
  }

  addUnsavedLink() {
    this.links.unshift({
      name: '',
      url: '',
      startTime: null,
      endTime: null,
      active: true,
      displayOrder: 0,
      createdAt: Date.now(),
      updatedAt: Date.now(),
    })
  }

  editLink(id) {
    this.editing = id;
  }

  async saveLink(link, index) {
    if (!link || !link.name || !link.url) return;
    if (link && link.url) {
      link.url = link.url.replace('https://', '').replace('http://', '');
    }
    let linkId = await this.linkService.addUserLink(link, this.profile.$id);
    if (!link.$id) this.links[index] = await this.linkService.getUserLink(linkId, this.profile.$id);
    this.editing = '';
    this.initDateTimes();
  }

  async updateLinkSchedule(index) {
    this.links[index].startTime = jQuery(`#starttime${index}`).data('date') || this.links[index].startTime || null;
    this.links[index].endTime = jQuery(`#endtime${index}`).data('date') || this.links[index].endTime || null;
    // console.log(this.links[index]);
    this.saveLink(this.links[index], index);
    this.updating = this.links[index].$id;
    setTimeout(() => {this.updating = ''}, 1000);
  }

  async removeLinkSchedule(index) {
    this.links[index].startTime = null;
    this.links[index].endTime = null;
    this.resetInputs = this.links[index].$id;
    setTimeout(() => {
        this.resetInputs = '';
        jQuery(`#starttime${index}`).datetimepicker();
        jQuery(`#endtime${index}`).datetimepicker();
    }, 200)
    this.saveLink(this.links[index], index);
  }

  async cancelLink(link, index) {
    if (link && !link.$id) {
      this.links.splice(index, 1);
    }
    if (link && link.$id) {
      this.editing = '';
      let oldLink = await this.linkService.getUserLink(link.$id, this.profile.$id);
      this.links[index].name = oldLink.name;
      this.links[index].url = oldLink.url;
    }
  }

  deleteLink(link, index) {
    this.links.splice(index, 1);
    this.linkService.deleteUserLink(link, this.profile.$id);
    this.links = _.sortBy(_.cloneDeep(this.links), 'displayOrder');
  }

  onDrop(value) {
    let elements = document.getElementsByClassName('saved-link');
    let ids = [];
    let displayOrder = 0;
    _.forEach(elements, (el) => {
      if (!el || !el.id) return;
      if (_.includes(ids, el.id)) return;
      displayOrder++;
      let link = _.find(this.links, (o) => { return o.$id === el.id });
      if (!link) return;
      link.displayOrder = displayOrder;
      ids.push(el.id)
      this.linkService.addUserLink(link, this.profile.$id);
    })
  }

  logout() {
    firebase.auth().signOut();
    this.goTo('login');
  }

  goTo(page, param?) {
    switch(page) {
      case 'home':
        this.router.navigate(['']);
        break;
      case 'login':
        this.router.navigate(['/login']);
        break;
      case 'display':
        this.router.navigate([`/display/${param}`])
    case '404':
        this.router.navigate(['/404']);
        break;
      case 'contact':
        // window.location.href = 'contact';
        break;
      default:
        break;
    }
  }

  ngOnDestroy() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/links/links.ts